<template>
  <div class="center">
    <template v-if="user.isAssistant">
      <v-icon icon="msf:person" :size="100" />
      {{ $t('meeting.lobby.waitingClient') }}
    </template>
    <template v-if="user.isClient">
      <v-icon icon="msf:headset_mic" :size="100" />
      {{ $t('meeting.lobby.waitingAssistant') }}
    </template>
    <template v-if="user.isObserver">
      <v-icon icon="msf:person" :size="100" />
      {{ $t('meeting.lobby.waitingAssistantClient') }}
    </template>
  </div>
</template>

<script setup>
import {useUserStore} from '@/stores'
const user = useUserStore()
</script>
<style lang="scss" scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: $background-neutral-93-fixed;
  color: $font-white-2;
  gap: $spacing-m;
  width: 100vw;
  height: 100vh;
  text-align: center;
}
</style>
